export const SS_APP_BACKDROP_ANIMATION = 'moovyBackdropAnimation'
export const SS_CONFIG_STORAGE_KEY = 'appConfig'
export const SS_APP_SETTINGS_KEY = 'appSettings'
export const SS_API_SETTINGS_KEY = 'apiSettings'
export const SS_ORGANIZATIONS_KEY = 'organizations'
export const SS_LOCATION_KEY = 'location'
export const SS_ERROR_MESSAGES_KEY = 'errorMessages'